import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { getTerms } from "../services/api/taxonomies/getTerms";
import { postUpdateTerm } from "../services/api/taxonomies/postUpdateTerm";

export const enum TermType {
  Games = "games",
  PlayerTypes = "player_types",
  ProjectType = "project_type",
  Teams = "teams",
  Schools = "schools",
  Courses = "courses",
  EventTypes = "event_type",
  TopicTypes = "topic_type",
}

export const useGetTerm = (
  type?: TermType,
  page?: number,
  per_page?: number,
  search?: string,
  desc?: boolean
) => {
  const initialData = {
    total_pages: 0,
    page: 0,
    total_entries: 0,
    entries: [],
  };
  const initialTerm = {
    termData: initialData,
    getTermLoading: false,
    getTermError: false,
  };

  if (!type) return initialTerm;
  const res = useQuery(
    [`get${type}`, page, search],
    () => getTerms(type, page, per_page, search, desc),
    { staleTime: Infinity }
  );
  return {
    termData: res.data ?? initialData,
    getTermLoading: res.isLoading,
    getTermError: res.isError,
  };
};

export const useUpdateTerm = (type?: TermType) => {
  const queryClient = useQueryClient();

  const mutation = useMutation(
    async (args: {
      auth_token: string;
      name?: string;
      id?: string;
      tax?: string;
      color?: string;
      img?: File;
    }) => {
      await postUpdateTerm(
        args.auth_token,
        args.name,
        args.id,
        args.tax,
        args.color,
        args.img
      );
    },
    { onSuccess: () => type && queryClient.invalidateQueries([`get${type}`]) }
  );

  return { mutate: mutation.mutate, mutateLoading: mutation.isLoading };
};
